export default {
  logo_text: '企业管理台',
  sidebar_index: '首页',
  sidebar_auth: '用户',
  sidebar_crm: '客户',
  sidebar_sys: '系统',
  sidebar_order: '工单',
  sidebar_app: '质检（临时）'
}
